import { fetchConfig } from "@theme/utilities";
import { cartPerformance } from "@theme/performance";

/**
 * Marketing parameters captured from the landing URL and persisted as cart
 * attributes so they flow through to the resulting order's note_attributes.
 */
const TRACKED_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "src",
  "gclid",
  "fbclid",
];

(async function captureUtmAttributes() {
  if (window.Shopify?.designMode) return;

  const searchParams = new URLSearchParams(window.location.search);
  /** @type {Record<string, string>} */
  const attributes = {};

  for (const key of TRACKED_PARAMS) {
    const value = searchParams.get(key)?.trim();
    if (value) attributes[key] = value;
  }

  if (Object.keys(attributes).length === 0) return;

  // Combined attribute consumed by the Shopify Function (`traffic_source`
  // qualifier). One cart attribute keeps the function input-query complexity
  // under 30; individual attributes are retained so existing order
  // note_attributes flows are unaffected.
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(attributes)) params.set(key, value);
  attributes._promo_traffic = params.toString();

  const startMarker = cartPerformance.createStartingMarker("utm-capture");

  try {
    const config = fetchConfig("json", {
      body: JSON.stringify({ attributes }),
    });

    await fetch(Theme.routes.cart_update_url, config);
  } catch {
    // Attribution is best-effort; never break the page if the write fails.
  } finally {
    cartPerformance.measureFromMarker(startMarker);
  }
})();
